"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TONE_MAPPING = exports.TEXTURE_ENCODING = exports.VISIBILITYMODE = exports.RENDERERTYPE = void 0;
var RENDERERTYPE;
(function (RENDERERTYPE) {
    /** The standard rendering engine */
    RENDERERTYPE["STANDARD"] = "standard";
    /** A basic version of the rendering engine */
    RENDERERTYPE["ATTRIBUTES"] = "attributes";
})(RENDERERTYPE = exports.RENDERERTYPE || (exports.RENDERERTYPE = {}));
var VISIBILITYMODE;
(function (VISIBILITYMODE) {
    /** The viewer shows the scene instantly */
    VISIBILITYMODE["INSTANT"] = "instant";
    /** The viewer shows the scene after the first session loading */
    VISIBILITYMODE["SESSION"] = "session";
    /** The viewer is shown once the 'show' property is set to true */
    VISIBILITYMODE["MANUAL"] = "manual";
})(VISIBILITYMODE = exports.VISIBILITYMODE || (exports.VISIBILITYMODE = {}));
var TEXTURE_ENCODING;
(function (TEXTURE_ENCODING) {
    TEXTURE_ENCODING["LINEAR"] = "linear";
    TEXTURE_ENCODING["SRGB"] = "srgb";
    TEXTURE_ENCODING["RGBE"] = "rgbe";
    TEXTURE_ENCODING["RGBM7"] = "rgbm7";
    TEXTURE_ENCODING["RGBM16"] = "rgbm16";
    TEXTURE_ENCODING["RGBD"] = "rgbd";
    TEXTURE_ENCODING["GAMMA"] = "gamma";
})(TEXTURE_ENCODING = exports.TEXTURE_ENCODING || (exports.TEXTURE_ENCODING = {}));
var TONE_MAPPING;
(function (TONE_MAPPING) {
    TONE_MAPPING["NONE"] = "none";
    TONE_MAPPING["LINEAR"] = "linear";
    TONE_MAPPING["REINHARD"] = "reinhard";
    TONE_MAPPING["CINEON"] = "cineon";
    TONE_MAPPING["ACES_FILMIC"] = "aces_filmic";
})(TONE_MAPPING = exports.TONE_MAPPING || (exports.TONE_MAPPING = {}));
//# sourceMappingURL=IRenderingEngine.js.map